import InventroyIndexView from "@/views/inventory/InventoryIndexView.vue";
import InventoryRoom from "@/views/inventory/inventoryRoom/InventoryRoom.vue";
import InventoryDefact from "@/views/inventory/inventoryDefact/InventoryDefact.vue";
import InventoryWareHouse from "@/views/inventory/inventoryWarehouse/InventoryWareHouse.vue";


const inventory = [
    {
        path: '/inventory',
        name: 'inventory',
        component: InventroyIndexView
    },
    {
        path: '/inventorywarehouse',
        name: 'inventorywarehouse',
        component: InventoryWareHouse
    },
    {
        path: '/inventorydefact',
        name: 'inventorydefact',
        component: InventoryDefact
    },
    {
        path: '/inventoryroom',
        name: 'inventoryroom',
        component: InventoryRoom
    },


    
]

export default inventory;